import { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Calendar from 'react-calendar';
import { confetti } from '../../components/imagepath';
import 'react-calendar/dist/Calendar.css';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ActionGetCustomerBirthdateDetail } from '../../store/Actions/PatientAction';

const Birthdayfolks = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const { birthdayDetail } = useSelector(state => state.patient);
  const dispatch = useDispatch();

  // Extract data from the nested structure
  const celebrationData = birthdayDetail?.[0] || {};
  const birthdayFolks = celebrationData.customer || [];
  const anniversaryFolks = celebrationData.anniversary || [];
  const totalCelebrations = birthdayFolks.length + anniversaryFolks.length;

  const formatDate = date => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };

  // Fetch birthday data for today on component mount
  useEffect(() => {
    const formattedDate = formatDate(new Date());
    setLoading(true);
    dispatch(ActionGetCustomerBirthdateDetail({ Query: `/${formattedDate} ` }));
    setTimeout(() => setLoading(false), 500);
  }, [dispatch]);

  const handleDateChange = date => {
    setSelectedDate(date);
    const formattedDate = formatDate(date);
    setLoading(true);
    dispatch(ActionGetCustomerBirthdateDetail({ Query: `/${formattedDate} ` }));
    setTimeout(() => setLoading(false), 500);
  };

  const getDisplayDate = (date) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const today = new Date();
      if (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()) {
        return 'today-highlight';
      }
    }
    return null;
  };

  return (
    <>
      <Header />
      <Sidebar />
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

          .birthday-container {
            background: #fdfdfd;
            min-height: 100vh;
            font-family: 'Plus Jakarta Sans', sans-serif;
            color: #1a1a1a;
          }

          /* Header Styling */
          .celebration-header {
            background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%);
            padding: 60px 40px;
            border-radius: 0 0 40px 40px;
            margin-bottom: -60px;
            color: white;
            position: relative;
            overflow: hidden;
          }
          .celebration-header::after {
            content: '';
            position: absolute;
            top: -50px;
            right: -50px;
            width: 200px;
            height: 200px;
            background: rgba(255,255,255,0.1);
            border-radius: 50%;
          }
          .header-content h1 {
            font-size: 42px;
            font-weight: 800;
            margin: 0;
            letter-spacing: -1px;
          }
          .header-content p {
            font-size: 18px;
            opacity: 0.9;
            margin-top: 10px;
          }

          /* Main Content Layout */
          .main-celebration-content {
            padding: 0 40px 60px;
            position: relative;
            z-index: 10;
          }

          .sticky-sidebar {
            position: sticky;
            top: 20px;
          }

          /* Calendar Styling */
          .calendar-box {
            background: white;
            border-radius: 24px;
            padding: 24px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.06);
            border: 1px solid rgba(0,0,0,0.02);
            margin-bottom: 24px;
          }
          .calendar-box h6 {
            font-weight: 700;
            margin-bottom: 20px;
            color: #2d3436;
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .calendar-box .react-calendar {
            border: none;
            width: 100%;
          }
          .calendar-box .react-calendar__tile--active {
            background: #6c5ce7 !important;
            border-radius: 12px;
            box-shadow: 0 8px 15px rgba(108, 92, 231, 0.3);
          }
          .calendar-box .react-calendar__month-view__days__day--neighboringMonth {
            color: #dfe6e9;
          }

          /* Stats Styling */
          .quick-stats {
            display: grid;
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .stat-pill {
            background: white;
            border-radius: 20px;
            padding: 20px;
            display: flex;
            align-items: center;
            gap: 15px;
            box-shadow: 0 10px 20px rgba(0,0,0,0.03);
            border: 1px solid rgba(0,0,0,0.02);
            transition: all 0.3s ease;
          }
          .stat-pill:hover {
            transform: scale(1.02);
          }
          .stat-icon {
            width: 50px;
            height: 50px;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
          }
          .icon-bday { background: #f0eeff; color: #6c5ce7; }
          .icon-anniv { background: #fff0f5; color: #fd79a8; }
          .stat-info .val { font-size: 24px; font-weight: 800; display: block; line-height: 1; }
          .stat-info .lbl { font-size: 13px; color: #636e72; font-weight: 600; margin-top: 4px; display: block; }

          /* Celebration List Section */
          .celebrations-glass-panel {
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(20px);
            border-radius: 32px;
            padding: 40px;
            border: 1px solid white;
            box-shadow: 0 30px 60px rgba(0,0,0,0.05);
            min-height: 600px;
          }

          .section-title {
            font-size: 24px;
            font-weight: 800;
            color: #2d3436;
            margin-bottom: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .date-badge {
            background: #f1f2f6;
            padding: 8px 20px;
            border-radius: 30px;
            font-size: 14px;
            color: #2d3436;
            font-weight: 700;
          }

          /* Card Styling - Horizontal / Modern */
          .person-card {
            background: white;
            border-radius: 24px;
            padding: 24px;
            display: flex;
            align-items: center;
            gap: 24px;
            margin-bottom: 24px;
            transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
            border: 1px solid #f1f2f6;
            position: relative;
            overflow: hidden;
            cursor: pointer;
          }
          .person-card::before {
            content: '🎉';
            position: absolute;
            font-size: 40px;
            top: -50px;
            right: 20px;
            transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
            opacity: 0;
            transform: rotate(20deg);
          }
          .person-card::after {
            content: '✨';
            position: absolute;
            font-size: 30px;
            bottom: -50px;
            left: 20px;
            transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
            opacity: 0;
            transform: rotate(-20deg);
          }
          .person-card:hover {
            transform: translateY(-8px) scale(1.02);
            box-shadow: 0 20px 40px rgba(108, 92, 231, 0.15);
            border-color: #6c5ce722;
          }
          .person-card:hover::before {
            top: 20px;
            opacity: 1;
            transform: rotate(0deg);
          }
          .person-card:hover::after {
            bottom: 20px;
            opacity: 1;
            transform: rotate(0deg);
          }
          .person-card:hover .person-avatar {
            transform: scale(1.1) rotate(5deg);
            box-shadow: 0 8px 15px rgba(0,0,0,0.1);
          }
          .avatar-container {
            position: relative;
          }
          .person-avatar {
            width: 80px;
            height: 80px;
            border-radius: 22px;
            background: #f8f9fd;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: 800;
            transition: all 0.4s ease;
          }
          .bday-avatar { color: #6c5ce7; background: #f0eeff; }
          .anniv-avatar { color: #fd79a8; background: #fff0f5; }

          .person-details { flex: 1; }
          .person-name { font-size: 22px; font-weight: 800; color: #2d3436; margin: 0 0 6px 0; }
          .person-sub { font-size: 15px; color: #636e72; display: flex; align-items: center; gap: 8px; font-weight: 500; }
          .person-sub span i { color: #6c5ce7; font-size: 14px; }

          .person-actions {
            display: flex;
            gap: 10px;
          }
          .action-btn {
            width: 44px;
            height: 44px;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 18px;
            transition: all 0.3s ease;
            text-decoration: none !important;
          }
          .btn-wa { background: #25D366; }
          .btn-call { background: #6c5ce7; }
          .action-btn:hover { transform: translateY(-5px); opacity: 0.9; box-shadow: 0 5px 15px rgba(0,0,0,0.2); }

          .type-tag {
            position: absolute;
            top: 24px;
            right: 24px;
            padding: 4px 12px;
            border-radius: 8px;
            font-size: 11px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .tag-bday { background: #f0eeff; color: #6c5ce7; }
          .tag-anniv { background: #fff0f5; color: #fd79a8; }

          .category-label {
            font-size: 13px;
            font-weight: 800;
            color: #b2bec3;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 20px;
            display: block;
          }

          .empty-state-modern {
            text-align: center;
            padding: 80px 40px;
          }
          .empty-state-modern img { width: 140px; margin-bottom: 30px; opacity: 0.7; }
          .empty-state-modern h4 { font-weight: 800; color: #2d3436; }
          .empty-state-modern p { color: #636e72; max-width: 300px; margin: 0 auto; }

          .floating-emoji {
            font-size: 40px;
            position: absolute;
            opacity: 0.1;
            animation: float 6s infinite ease-in-out;
          }
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
          }
        `}
      </style>
      <div className="page-wrapper">
        <div className="birthday-container">
          {/* Header Section */}
          <div className="celebration-header">
            <span className="floating-emoji" style={{ top: '20%', left: '10%' }}>🎂</span>
            <span className="floating-emoji" style={{ top: '60%', left: '80%' }}>✨</span>
            <span className="floating-emoji" style={{ top: '10%', left: '70%' }}>🎈</span>
            <span className="floating-emoji" style={{ top: '70%', left: '15%' }}>💖</span>

            <div className="header-content">
              <h1>Celebrations Hub</h1>
              <p>Keep the spirit alive! Connect with folks on their special days.</p>
            </div>
          </div>

          <div className="main-celebration-content">
            <div className="row">
              {/* Sticky Sidebar */}
              <div className="col-lg-4">
                <div className="sticky-sidebar">
                  <div className="calendar-box">
                    <h6><span>📅</span> Select Timeline</h6>
                    <Calendar
                      onChange={handleDateChange}
                      value={selectedDate}
                      tileClassName={tileClassName}
                    />
                  </div>

                  <div className="quick-stats">
                    <div className="stat-pill">
                      <div className="stat-icon icon-bday">🎂</div>
                      <div className="stat-info">
                        <span className="val">{birthdayFolks.length}</span>
                        <span className="lbl">Birthdays Today</span>
                      </div>
                    </div>
                    <div className="stat-pill">
                      <div className="stat-icon icon-anniv">💖</div>
                      <div className="stat-info">
                        <span className="val">{anniversaryFolks.length}</span>
                        <span className="lbl">Anniversaries Today</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Celebrations Feed */}
              <div className="col-lg-8">
                <div className="celebrations-glass-panel">
                  <div className="section-title">
                    <span>Timeline Feed</span>
                    <div className="date-badge">
                      {isToday(selectedDate) ? '✨ Today, ' : ''}
                      {getDisplayDate(selectedDate)}
                    </div>
                  </div>

                  {loading ? (
                    <div style={{ textAlign: 'center', padding: '100px 0' }}>
                      <Spin size="large" />
                      <p style={{ marginTop: '20px', color: '#636e72', fontWeight: '600' }}>Gathering celebrations...</p>
                    </div>
                  ) : totalCelebrations === 0 ? (
                    <div className="empty-state-modern">
                      <img src={confetti} alt="Empty" />
                      <h4>Quiet Day!</h4>
                      <p>No birthdays or anniversaries found for this date. Check another one!</p>
                    </div>
                  ) : (
                    <div className="feed-container">
                      {/* Birthdays */}
                      {birthdayFolks.length > 0 && (
                        <div className="mb-5">
                          <span className="category-label">🎂 Birthday Buddies</span>
                          {birthdayFolks.map((item, idx) => {
                            const getInitials = (name) => name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || '?';
                            const birthDate = new Date(item.birthDate);
                            const formattedDate = birthDate.getUTCDate() + ' ' + birthDate.toLocaleString('default', { month: 'short' });

                            return (
                              <div key={`bday-${idx}`} className="person-card">
                                <div className="type-tag tag-bday">Birthday</div>
                                <div className="avatar-container">
                                  <div className="person-avatar bday-avatar">
                                    {getInitials(item.name)}
                                  </div>
                                </div>
                                <div className="person-details">
                                  <h3 className="person-name">{item.name}</h3>
                                  <div className="person-sub">
                                    <span>🎂 {formattedDate}</span>
                                    <span style={{ opacity: 0.3 }}>•</span>
                                    <span><i className="fa fa-phone"></i> {item.phoneNo || 'No Number'}</span>
                                    <span style={{ opacity: 0.3 }}>•</span>
                                    <span><i className="fa fa-envelope"></i> {item.email || 'No Email'}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {/* Anniversaries */}
                      {anniversaryFolks.length > 0 && (
                        <div>
                          <span className="category-label">💍 Anniversary Folks</span>
                          {anniversaryFolks.map((item, idx) => {
                            const customer = item.customerId || {};
                            const getInitials = (name) => name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || '?';
                            const annivDate = new Date(item.anniversaryDate);
                            const formattedDate = annivDate.getUTCDate() + ' ' + annivDate.toLocaleString('default', { month: 'short' });

                            return (
                              <div key={`anniv-${idx}`} className="person-card">
                                <div className="type-tag tag-anniv">Anniversary</div>
                                <div className="avatar-container">
                                  <div className="person-avatar anniv-avatar">
                                    {getInitials(customer.name)}
                                  </div>
                                </div>
                                <div className="person-details">
                                  <h3 className="person-name">{customer.name}</h3>
                                  <div className="person-sub">
                                    <span>💖 {formattedDate}</span>
                                    <span style={{ opacity: 0.3 }}>•</span>
                                    <span><i className="fa fa-phone"></i> {customer.phoneNo || 'No Number'}</span>
                                    <span style={{ opacity: 0.3 }}>•</span>
                                    <span><i className="fa fa-envelope"></i> {customer.email || 'No Email'}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Birthdayfolks;
